








































import { Component } from 'vue-property-decorator'
import QuestionRadio from './QuestionRadio.vue'
import QuestionCheckBox from './QuestionCheckBox.vue'
import QuestionSelect from './QuestionSelect.vue'
import ProgressQuestion from './ProgressQuestion.vue'
import ExamTestQuestionBodyMixin from './ExamTestQuestionBodyMixin'
import { mixins } from 'vue-class-component'
import Simplemde from './Simplemde.vue'

@Component({
  components: {
    QuestionRadio,
    QuestionCheckBox,
    QuestionSelect,
    ProgressQuestion,
    Simplemde
  }
})
export default class ExamTestQuestionBodyMobile extends mixins(ExamTestQuestionBodyMixin) {}
